import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ImportEvaluationFactory } from '@shared/factories/import-evaluation/import-evaluation.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImportEvaluationGuard  {
  route:ActivatedRouteSnapshot;
  state: RouterStateSnapshot;
  constructor(private apiService: ApiServiceService,
    private importEvaluationFactory: ImportEvaluationFactory,
    private router: Router,
    private context: ContextFactory
  ){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.route = route;
      this.state = state;
      return this.getImportEvaluation();
  }

  getImportEvaluation(){
    if(this.context.user && this.context.jwtToken){
      if(this.route.queryParams['access']){
        return this.apiService.get('sharedevaluations?access=' + encodeURIComponent( this.route.queryParams['access']))
          .then((data:any)=> {
            data.result = 'ok';
            this.importEvaluationFactory.setEvaluationImportData(data);
            this.router.navigate(['dashboard']);
            return false;
          },(errorData:any)=>{
            let data: any = {}
            if(errorData.status === 404){
              data.result = 'notShared';
            }else if(errorData.status === 403){
              data.result = 'noSubscription';
            }else{
              data.result = 'unexpectedError';
            }
            this.importEvaluationFactory.setEvaluationImportData(data);
            this.router.navigate(['dashboard']);
            return false;
          })
      }else{
        this.importEvaluationFactory.setEvaluationImportData({result: 'unexpectedError'});
        this.router.navigate(['dashboard']);
        return false;
      }
    }
    return true;
  }
}
